export default function HowItWorks() {
  return (
    <section id="como-funciona" className="py-[60px] bg-[#020617] border-t border-b border-[#111827]">
      <div className="max-w-[1120px] mx-auto px-4">
        <h2 className="text-[1.8rem] mb-2 font-bold text-[#e5e7eb]">Como funciona o Tarot virtual</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
          <div>
            <p className="text-[#cbd5f5] mb-4">
              O serviço combina a simbologia do Tarot com inteligência artificial para lhe dar respostas
              rápidas, coerentes e adaptadas às suas questões. Cada conversa é privada e o acesso está
              disponível 24 horas por dia.
            </p>
            <p className="text-[#cbd5f5] mb-4">
              Compra um pacote de minutos, entra na área do cliente e fala com o consultor virtual
              que quiser. Cada resposta consome minutos do seu saldo. Quando o saldo termina,
              pode recarregar a qualquer momento.
            </p>
            <ul className="list-none p-0 my-4 space-y-1.5">
              <li className="relative pl-[18px] text-[0.95rem] text-[#e5e7eb] before:content-['•'] before:absolute before:left-0 before:top-0 before:text-[#facc15]">
                Chat privado e confidencial
              </li>
              <li className="relative pl-[18px] text-[0.95rem] text-[#e5e7eb] before:content-['•'] before:absolute before:left-0 before:top-0 before:text-[#facc15]">
                Respostas imediatas
              </li>
              <li className="relative pl-[18px] text-[0.95rem] text-[#e5e7eb] before:content-['•'] before:absolute before:left-0 before:top-0 before:text-[#facc15]">
                4 consultores com estilos diferentes
              </li>
              <li className="relative pl-[18px] text-[0.95rem] text-[#e5e7eb] before:content-['•'] before:absolute before:left-0 before:top-0 before:text-[#facc15]">
                Saldo de minutos partilhado entre consultores
              </li>
            </ul>
          </div>

          <div className="bg-[radial-gradient(circle_at_top_left,rgba(148,163,184,0.2),rgba(15,23,42,0.95))] rounded-[18px] p-5 border border-[rgba(148,163,184,0.35)] shadow-[0_16px_35px_rgba(15,23,42,0.7)]">
            <h3 className="mt-0 mb-3 text-lg font-bold text-[#e5e7eb]">Passo a passo</h3>
            <ol className="pl-[18px] m-0 mb-4 space-y-2 text-[#cbd5f5]">
              <li>Crie a sua conta ou inicie sessão.</li>
              <li>Escolha um pacote de minutos e conclua o pagamento.</li>
              <li>Entre na área do cliente e selecione um consultor.</li>
              <li>Coloque a sua pergunta e acompanhe o saldo de minutos em tempo real.</li>
            </ol>
            <a
              href="#planos"
              className="w-full inline-flex items-center justify-center rounded-full px-4 py-2 text-[0.95rem] font-medium bg-gradient-to-br from-[#8b5cf6] to-[#ec4899] text-[#f9fafb] shadow-[0_8px_20px_rgba(15,23,42,0.6)] hover:translate-y-[-1px] hover:brightness-105 transition-all"
            >
              Ver pacotes de minutos
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
